export default __webpack_public_path__ + "static/media/nefesh to achim.2be7a032.svg";